(function () {
    'use strict';

    angular.module('app')
        .factory('tourHelper', ['$log', TourHelper]);

    function TourHelper($log) {
        const factory = this;
        const MAX_TOUR_MONTHS = 3;

        factory.getTourDates = getTourDates;
        factory.isConcertValidForTour = isConcertValidForTour;
        
        /**
         * Find the start and end date of a tour.
         */
        function getTourDates(tour) {
            const startTimes = tour.concerts.map(c => new Date(c.concert_start_time).valueOf());
            const startDate = new Date(Math.min(...startTimes));
            const endDate = new Date(Math.max(...startTimes));

            return {
                startDate,
                endDate
            };
        };

        function isConcertValidForTour(tour, concert) {
            const potentialTour = {
                concerts: [
                    ...tour.concerts.map(c => ({ concert_start_time: c.concert_start_time })),
                    { concert_start_time: concert.concert_start_time }
                ]
            }
            const { startDate, endDate } = factory.getTourDates(potentialTour);
            const months = moment(endDate).diff(moment(startDate), 'months', true);
            return months <= MAX_TOUR_MONTHS;
        }

        return factory;
    }
})();